export default __webpack_public_path__ + "static/media/list2.e2ea9fda.svg";